<div [class.collapsed]="isCollapsed$ | async" [class.dropdown-open]="dropdownOpen$ | async" [ngClass]="levelClass"
  class="sidenav-item">
  @if (item.type === 'subheading' && item.isVisible) {
    <div fxLayout="row" fxLayoutAlign="space-between center"
      [ngClass]="item.customClass" class="subheading">
      <span>{{ item.name | uppercase }}</span>
      @if (item.addButton) {
        <span class="add-button-wrapper" fxLayoutAlign="center center">
          <button type="button" (click)="addFolder('add', item.itemType)" class="addbutton" matTooltip="Add Folder">
            <mat-icon>add</mat-icon>
          </button>
        </span>
      }
    </div>
  }
  @if (item.type !== 'subheading' && item.isVisible && item.itemType != eNavItemType.archives && item.itemType != eNavItemType.documents) {
    @if (item.subItems?.length > 0 || isFunction(item.routeOrFunction)) {
      <a (click)="handleClick()" class="sidenav-item-link pointer" fxLayout="row" fxLayoutAlign="start center" matRipple>
        <ng-container *ngTemplateOutlet="linkContent"></ng-container>
      </a>
    } @else {
      <a [routerLinkActiveOptions]="{ exact: getRouterLinkActive(item) }" [routerLink]="item.routeOrFunction"
        class="sidenav-item-link pointer" fxLayout="row" fxLayoutAlign="start center"
        matRipple routerLinkActive="active">
        <ng-container *ngTemplateOutlet="linkContent"></ng-container>
      </a>
    }
  }

  @if (item.itemType == eNavItemType.archives || item.itemType == eNavItemType.documents) {
    <mat-tree [dataSource]="item.itemType == eNavItemType.archives ? archivesDataSource : documentsDataSource" [treeControl]="treeControl">
      <!-- Leaf Node -->
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [matTreeNodePaddingIndent]="node.paddingIndent" class="tree-node-wrapper">
        <div class="sidenav-item-link tree-link" [routerLinkActiveOptions]="{ exact: node.pathMatchExact || false }"
          routerLinkActive="active" (mouseenter)="node.showMenu = true" (mouseleave)="node.showMenu = false">
          <div fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between center">
            <span fxLayout="row" fxLayoutAlign="start center" [routerLink]="node.url" (click)="navigationOpen(node.url, node.id)" fxLayoutGap="10px" class="tree-label">
              <mat-icon class="folder-icon">folder</mat-icon>
              <span class="cursor tree-name">{{node.name}}</span>
            </span>
            <button mat-icon-button [matMenuTriggerFor]="menu" class="tree-menu-btn"
              [style.visibility]="node.showMenu ? 'visible' : 'hidden'" aria-label="Folder Options">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button (click)="editFolder('edit', node.name, node.id, node.itemType)" mat-menu-item>
                <mat-icon>edit</mat-icon>
                <span>Edit</span>
              </button>
              <button (click)="deleteFolder(node.id, node.itemType)" mat-menu-item>
                <mat-icon>delete</mat-icon>
                <span>Delete</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </mat-tree-node>
      <!-- Expandable Node -->
      <mat-tree-node *matTreeNodeDef="let childnode; when: hasChild" matTreeNodePadding [matTreeNodePaddingIndent]="childnode.paddingIndent" class="tree-node-wrapper">
        <div class="sidenav-item-link tree-link" [routerLinkActiveOptions]="{ exact: childnode.pathMatchExact || false }"
          routerLinkActive="active" (mouseenter)="childnode.showMenu = true" (mouseleave)="childnode.showMenu = false">
          <div fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between center">
            <span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px" class="tree-label">
              <button mat-icon-button matTreeNodeToggle class="tree-toggle-btn" [attr.aria-label]="'toggle ' + childnode.name">
                <mat-icon class="toggle-icon">
                  {{treeControl.isExpanded(childnode) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
              </button>
              <span fxLayout="row" fxLayoutAlign="start center" [routerLink]="childnode.url" (click)="navigationOpen(childnode.url, childnode.id)" fxLayoutGap="8px">
                <mat-icon class="folder-icon">folder</mat-icon>
                <span class="cursor tree-name">{{childnode.name}}</span>
              </span>
            </span>
            <button mat-icon-button [matMenuTriggerFor]="menu" class="tree-menu-btn"
              [style.visibility]="childnode.showMenu ? 'visible' : 'hidden'" aria-label="Folder Options">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button (click)="editFolder('edit', childnode.name, childnode.id, childnode.itemType)" mat-menu-item>
                <mat-icon>edit</mat-icon>
                <span>Edit</span>
              </button>
              <button (click)="deleteFolder(childnode.id)" mat-menu-item>
                <mat-icon>delete</mat-icon>
                <span>Delete</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </mat-tree-node>
    </mat-tree>
  }


  <ng-template #linkContent>
    @if (level === 0 ) {
      <mat-icon class="icon">{{ item.icon }}</mat-icon>
    }
    @if (level > 0) {
      <div class="text-icon" fxFlex="none"><mat-icon>navigate_next</mat-icon></div>
    }

    <span class="name">{{ item.name }}</span>
    <span fxFlex><!-- fill space --></span>
    @if (item.badge) {
      <span [style.background-color]="item.badgeColor" class="badge">{{
      item.badge }}</span>
    }
    @if (item.subItems && item.subItems.length > 0) {
      <mat-icon [class.rotate]="dropdownOpen$ | async"
        class="expand-indicator">
        expand_more
      </mat-icon>
    }
  </ng-template>

  <div [@dropdownOpen]="dropdownOpen$ | async" class="dropdown" fxLayout="column">
    @for (subItem of item.subItems; track (subItem.id || subItem.routeOrFunction || (subItem.name + '_' + (subItem.position ?? $index)))) {
      <fury-sidenav-item [item]="subItem" [level]="level+1"></fury-sidenav-item>
    }
  </div>
</div>